export const isValidDate = (date: unknown) => {
  if (date === null || date === undefined) return false;
  return date instanceof Date && !Number.isNaN(date.getTime());
};

export default isValidDate;
